import { motion } from "@/components/motion";
import { Award, Users, MapPin, Calendar, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const stats = [
{ icon: Calendar, label: "Years of Experience", value: "35+" },
{ icon: Users, label: "Happy Clients", value: "4,000+" },
{ icon: MapPin, label: "States Served", value: "15+" },
{ icon: Award, label: "Quality Certified", value: "ISI" }];


const About = () =>
<section id="about" className="py-20 md:py-28 bg-background">
    <div className="container mx-auto px-4">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}>
        
          <p className="text-accent-strong font-display text-sm uppercase tracking-[0.2em] mb-2">
            Our Story
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
            A Legacy of Trust in Steel
          </h2>
          <p className="font-body text-muted-foreground leading-relaxed mb-4">Established in 1990 by Taher and Khozem Gadli, Taher Steel Tube Co. is a partnership firm dealing primarily in Galvanized, Stainless, Mild Steel, ERW, and Seamless Tubes. We also deal with industrial fittings, valves, and fire safety equipment — a one-stop shop for all your industrial needs.




        </p>
          <p className="font-body text-muted-foreground leading-relaxed">
            Delivering value and customer satisfaction on a consistent basis has
            helped us evolve and build a name in the steel industry. Our
            clientele includes Government, Semi-Government, Public, and Private
            undertakings across the country.
          </p>
          <div className="mt-6">
            <Link
              to="/careers"
              className="inline-flex items-center gap-2 text-accent font-display font-semibold text-sm hover:brightness-110 transition"
            >
              Join Our Team <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </motion.div>

        <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="grid grid-cols-2 gap-4">
        
          {stats.map((s) =>
        <div
          key={s.label}
          className="bg-card border border-border rounded-lg p-6 text-center hover:shadow-lg transition-shadow">
          
              <s.icon className="w-8 h-8 text-accent mx-auto mb-3" />
              <p className="font-display text-2xl md:text-3xl font-bold text-foreground">
                {s.value}
              </p>
              <p className="font-body text-sm text-muted-foreground mt-1">
                {s.label}
              </p>
            </div>
        )}
        </motion.div>
      </div>
    </div>
  </section>;


export default About;